import get from 'lodash/get';

export function pluckStyleBlock(
  theme: Object,
  defaultTheme: Object,
  property: string,
) {
  return get(theme, property, get(defaultTheme, property, ''));
}

export function pluckComponentProperty(
  theme: Object,
  component: string,
  property: string,
) {
  return get(theme, [component, property], undefined);
}

export function pluckPropertyIfExists(
  theme: Object,
  path: string,
  property: string,
) {
  let value = get(theme, path + '.' + property, false);
  return value ? property + ': ' + value + ';' : '';
}

const ThemeSelector = {
  pluckStyleBlock,
  pluckComponentProperty,
  pluckPropertyIfExists,
};

export default ThemeSelector;
